import Channel from './';
const AppChannel = new Channel('App');

if (module.hot) {
    window.__APP_CHANNEL__ = AppChannel;
}

export default AppChannel;
